// extracted by mini-css-extract-plugin
module.exports = {"width-160":"_1jPE45FwDQ","width-430":"_1MFMRRgEjQ","remark":"UTc4OHW6I3","reminder-block":"FG_qW8rBwb","text-button":"MQg71WIROi"};